@if (memberCounts) {
  <ul class="inline-list m-full-width">
    @if (memberCounts.userCount) {
      <li class="m-guts-p-v-half par par--light">
        {{ memberCountI18n }}
      </li>
    }
    @if (memberCounts.anonymousUserCount === 1) {
      <li class="m-guts-p-v-half par par--light">
        <strong>&middot;</strong> {{ anonymousCountSingleI18n }}
      </li>
    }
    @if (memberCounts.anonymousUserCount > 1) {
      <li class="m-guts-p-v-half par par--light">
        <strong>&middot;</strong> {{ anonymousCountI18n }}
      </li>
    }
    @if (remainingSeats) {
      <li
        class="m-guts-p-v-half par par--light"
        [ngClass]="{
          'error-text': isOverSubscribed,
          'font-bold': isOverSubscribed,
        }"
      >
        <strong>&middot;</strong> {{ remainingSeats }}
        <da-icon
          icon="information-circle"
          type="solid-small"
          class="guts-m-l-half tw-reset tw-inline-block tw-align-middle tw-text-neutral-600"
          [ariaLabel]="remainingSeatsTooltip"
          [ngbTooltip]="remainingSeatsTooltip"
          container="body"
        ></da-icon>
      </li>
    }
  </ul>
}
